import React, { useState } from 'react';
import { AI_AGENTS } from '../../../../utils/constants/ai-agents';
import KnowledgeFilesModal from '../modals/KnowledgeFilesModal';
import { useTheme } from '../../../../theme-context';

const AiAgents = () => {
    const [showFilesModal, setShowFilesModal] = useState<{ show: boolean, agent: any }>()

        const { theme } = useTheme();

    const onClickFilesAgent = (agent: any) => {
        setShowFilesModal({
            show: true,
            agent: agent
        })
    }

    const onHideFilesModal = () => {
        setShowFilesModal(undefined)
    }

    return (
        <div>
            {AI_AGENTS?.map((item: any, idx: number) => {
                return (
                    <div key={item} className='flex flex-row items-center cursor-pointer hover:opacity-80 px-1 pr-0 sm:px-2 sm:pr-0 mb-3'
                                onClick={() => onClickFilesAgent(item)}>
                    <img
                        src={
                            theme === 'dark'
                                ? '/assets/navigation-icons/sidebar/new-question-white.svg'
                                : '/assets/navigation-icons/sidebar/new-question.svg'
                        }
                        className="object-contain w-5 h-5 sm:w-[23px] sm:h-[23px] mr-2 sm:mr-3"
                    />
                                     <p className="text-sm sm:text-base dark:text-primary-dark">
                        Upload on knowledge base
                    </p>
                                </div>
                          
                     
                )
            })}

            {showFilesModal?.show &&
                <KnowledgeFilesModal
                    openModal={showFilesModal?.show}
                    activeAgent={showFilesModal?.agent}
                    handleCloseModal={onHideFilesModal}
                />
            }
        </div>
    )
}
export default AiAgents;